import { cn } from "@/lib/utils"

interface BrandMarkProps {
	className?: string
	animated?: boolean
	title?: string
}

/**
 * The zPLANEM symbol, from the supplied `Logo - Symbol.svg` (2026-07-31).
 * Path data is the designer's, verbatim — only the fills are swapped for
 * `--brand-mark-ink` / `--brand-mark-accent` so the mark survives dark mode
 * (the asset's navy is within 1.1:1 of the dark card surface).
 *
 * The artwork is 28×37, not square. Callers size it with a square box; the
 * default `preserveAspectRatio` fits it centred without distortion.
 */
export function BrandMark({
	className,
	animated = false,
	title,
}: BrandMarkProps) {
	return (
		<svg
			viewBox="0 0 28 37"
			fill="none"
			role={title ? "img" : "presentation"}
			aria-hidden={title ? undefined : true}
			aria-label={title}
			className={cn("block", className)}
		>
			{/* The Z counter is carved out of the same path as the frame, so the
			    loader spins the whole mark rather than the Z alone. */}
			<g className={animated ? "zplanem-loader-z" : undefined}>
				<path
					d="M5.01489 8.62402H7.40295L7.40295 16.2439H5.01489V8.62402Z"
					fill="var(--brand-mark-ink)"
				/>
				<path
					d="M7.38672 13.8716H10.252V9.91748H26.6895V36.3237H0V9.91748H7.38672V13.8716ZM5.01465 13.8882V16.2437L17.2812 16.2378L5.29199 30.1226V31.8579H6.94434L21.9229 14.5356V13.8813L5.01465 13.8882Z"
					fill="var(--brand-mark-ink)"
				/>
				<path
					d="M14.2456 1.39996L7.06356 9.83579L5.01484 8.62407L12.3057 1.65918e-05L14.2456 1.39996Z"
					fill="var(--brand-mark-ink)"
				/>
				<path
					d="M10.0299 32.0151L11.9691 29.6524L28 29.6524L28 32.0151L10.0299 32.0151Z"
					fill="var(--brand-mark-accent)"
				/>
			</g>
		</svg>
	)
}
